import { render, staticRenderFns } from "./main-navbar.vue?vue&type=template&id=edf64408&scoped=true"
import script from "./main-navbar.vue?vue&type=script&lang=js"
export * from "./main-navbar.vue?vue&type=script&lang=js"
import style0 from "./main-navbar.vue?vue&type=style&index=0&id=edf64408&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf64408",
  null
  
)

export default component.exports